import PostModal from './PostModal';

customElements.define('post-modal', PostModal);
